module.exports = __webpack_public_path__ + "5916ba6fee7449fd3b8af52fe4b42109.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1085
// module chunks = 0